import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute } from './components/auth/ProtectedRoute'

// Pages
import Login from './pages/Login'
import PersonalizedDashboard from './components/dashboard/PersonalizedDashboard'
import Bots from './pages/Bots'
import BotDetail from './pages/BotDetail'
import BotCreate from './pages/BotCreate'
import BotEdit from './pages/BotEdit'
import Menus from './pages/Menus'
import MenuCreate from './pages/MenuCreate'
import MenuEdit from './pages/MenuEdit'
import Templates from './pages/Templates'
import TemplateCreate from './pages/TemplateCreate'
import TemplateManagement from './pages/TemplateManagement'
import FlowManagement from './pages/FlowManagement'
import Conversations from './pages/Conversations'
import ConversationDetail from './pages/ConversationDetail'
import QuickRepliesPage from './pages/QuickRepliesPage'
import Clients from './pages/Clients'
import Users from './pages/Users'
import Admins from './pages/Admins'
import AdminManagement from './pages/AdminManagement'
import SubscriptionPlans from './pages/SubscriptionPlans'
import UserManagement from './pages/UserManagement'
import BotMessages from './pages/BotMessages'
import Settings from './pages/Settings'
import Financial from './pages/Financial'
import InvoiceCreate from './pages/InvoiceCreate'
import InvoiceView from './pages/InvoiceView'
import InvoicePayment from './pages/InvoicePayment'
import Subscription from './pages/Subscription'

function App() {

  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Rotas públicas */}
        <Route 
          path="/login" 
          element={<Login />} 
        />

        {/* Rotas protegidas */}
        <Route path="/" element={<ProtectedRoute />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<PersonalizedDashboard />} />
          
          {/* Bots */}
          <Route path="bots" element={<Bots />} />
          <Route path="bots/create" element={<BotCreate />} />
          <Route path="bots/:id" element={<BotDetail />} />
          <Route path="bots/:id/edit" element={<BotEdit />} />
          
          {/* Menus */}
          <Route path="menus" element={<Menus />} />
          <Route path="menus/create" element={<MenuCreate />} />
          <Route path="menus/:id/edit" element={<MenuEdit />} />
          
          {/* Templates */}
          <Route path="templates" element={<Templates />} />
          <Route path="templates/create" element={<TemplateCreate />} />
          <Route path="templates/management" element={<TemplateManagement />} />
          <Route path="templates/flows" element={<FlowManagement />} />
          
          {/* Conversas */}
          <Route path="conversations" element={<Conversations />} />
          <Route path="conversations/:id" element={<ConversationDetail />} />
          {/* Mensagens rápidas (atendentes) */}
          <Route path="quick-replies" element={<QuickRepliesPage />} />
          
          {/* Clientes */}
          <Route path="clients" element={<Clients />} />
          
          {/* Usuários */}
          <Route path="users" element={<Users />} />
          <Route path="user-management" element={<UserManagement />} />
          
          {/* Admins (apenas super admin) */}
          <Route path="admins" element={<Admins />} />
          <Route path="admin-management" element={<AdminManagement />} />
          <Route path="subscription-plans" element={<SubscriptionPlans />} />
          
          {/* Mensagens do Bot */}
          <Route path="bot-messages" element={<BotMessages />} />
          
          {/* Configurações */}
          <Route path="settings" element={<Settings />} />
          <Route path="financial" element={<Financial />} />
          <Route path="invoices/create" element={<InvoiceCreate />} />
          <Route path="invoices/:id" element={<InvoiceView />} />
          <Route path="invoices/:id/payment" element={<InvoicePayment />} />
          <Route path="subscription" element={<Subscription />} />
        </Route>

        {/* Rota 404 */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  )
}

export default App
